// extracted by css-extract-rspack-plugin
export default {"TrustpilotContainer":"TrustPilotBadge-module__TrustpilotContainer","ratingSpan":"TrustPilotBadge-module__ratingSpan","ratingInnerSpan":"TrustPilotBadge-module__ratingInnerSpan"};